import React from 'react';
import { createCn } from '../../../helpers/utils';
import classes from '../styles.module.scss';
import { KtzhProtocolDocument } from '../../../utils/ktzh-protocol-format';
import { formatProtocolRichText } from '../../../utils/format-protocol-text';
import { PROTOCOL_AI_DISCLAIMER, PROTOCOL_AI_FOOTER } from '../../../utils/protocol-footer';

const cn = createCn('file', classes);

type Props = {
  doc: KtzhProtocolDocument;
  onOpenSpeeches?: () => void;
};

const KtzhProtocolView = ({ doc, onOpenSpeeches }: Props) => (
  <article className={cn('ktzh-protocol')}>
    <header className={cn('ktzh-protocol-header')}>
      <div className={cn('ktzh-protocol-title')}>ПРОТОКОЛ</div>
      {(doc.chairTitle || doc.chairName) && (
        <p className={cn('ktzh-protocol-chair')}>
          совещания под председательством
          {[doc.chairTitle, doc.chairName].filter(Boolean).length ? ', ' : ''}
          {[doc.chairTitle, doc.chairName].filter(Boolean).join(' ')}
        </p>
      )}
      <div className={cn('ktzh-protocol-meta-row')}>
        <span className={cn('ktzh-protocol-meta-city')}>г. {doc.city}</span>
        <span className={cn('ktzh-protocol-meta-num')}>№{doc.protocolNumber}</span>
        <span className={cn('ktzh-protocol-meta-date')}>
          {doc.dateLabel || '«___» __________ 20__ г.'}
        </span>
      </div>
      {doc.topicLine && (
        <p className={cn('ktzh-protocol-topic')}>{doc.topicLine}</p>
      )}
    </header>

    {doc.established.length > 0 && (
      <section className={cn('ktzh-protocol-section')}>
        <h2 className={cn('ktzh-protocol-section-title')}>Совещанием установлено:</h2>
        <div className={cn('ktzh-protocol-block')}>
          {doc.established.map((item, i) => (
            <p
              key={i}
              className={cn('ktzh-protocol-para')}
              dangerouslySetInnerHTML={{ __html: formatProtocolRichText(item) }}
            />
          ))}
        </div>
      </section>
    )}

    {doc.decisionGroups.length > 0 && (
      <section className={cn('ktzh-protocol-section')}>
        <h2 className={cn('ktzh-protocol-section-title')}>Принятые решения:</h2>
        <div className={cn('ktzh-protocol-block')}>
          {doc.decisionGroups.map((group, gi) => (
            <div key={gi} className={cn('ktzh-protocol-decision-group')}>
              <p className={cn('ktzh-protocol-assignee')}>{group.header}</p>
              {group.items.map((item, ii) => (
                <p
                  key={ii}
                  className={cn('ktzh-protocol-para', { indented: true })}
                  dangerouslySetInnerHTML={{ __html: formatProtocolRichText(item) }}
                />
              ))}
            </div>
          ))}
        </div>
      </section>
    )}

    {(doc.signatureTitle || doc.signatureName) && (
      <div className={cn('ktzh-protocol-signature-block')}>
        <span className={cn('ktzh-protocol-signature-title')}>{doc.signatureTitle}</span>
        <span className={cn('ktzh-protocol-signature-line')} />
        <span className={cn('ktzh-protocol-signature-name')}>{doc.signatureName}</span>
      </div>
    )}

    {doc.participants.length > 0 && (
      <section className={cn('ktzh-protocol-section')}>
        <h2 className={cn('ktzh-protocol-section-title')}>Список участников</h2>
        <div className={cn('ktzh-protocol-table-wrap')}>
          <table className={cn('ktzh-protocol-table')}>
            <thead>
              <tr>
                <th>№</th>
                <th>ФИО</th>
                <th>Должность</th>
              </tr>
            </thead>
            <tbody>
              {doc.participants.map(p => (
                <tr key={p.num}>
                  <td>{p.num}</td>
                  <td>{p.name}</td>
                  <td>{p.position}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    )}

    {onOpenSpeeches && (
      <p className={cn('ktzh-protocol-link')}>
        <button type="button" className={cn('ktzh-protocol-link-btn')} onClick={onOpenSpeeches}>
          Открыть полный ход совещания и аналитику →
        </button>
      </p>
    )}

    <footer className={cn('protocol-ai-footer')}>
      <div className={cn('protocol-ai-badge')}>
        <span className={cn('protocol-ai-badge-model')}>{PROTOCOL_AI_FOOTER}</span>
        <span className={cn('protocol-ai-badge-disclaimer')}>{PROTOCOL_AI_DISCLAIMER}</span>
      </div>
    </footer>
  </article>
);

export default KtzhProtocolView;
